export default __webpack_public_path__ + "static/media/validation-mobile.29719f1b.svg";